import { __rest } from "tslib";
import clsx from 'clsx';
import React from 'react';
import { navVariants } from './variants';
const Nav = React.forwardRef((_a, ref) => {
    var { className, children, orient = 'horizontal', appereance = 'tab', size, fit } = _a, props = __rest(_a, ["className", "children", "orient", "appereance", "size", "fit"]);
    return (React.createElement("div", Object.assign({ ref: ref }, props, { className: clsx(navVariants({ orient, appereance, size }), {
            'cmp-nav-fit': fit,
        }, className), role: 'tablist' }),
        children,
        React.createElement("div", { className: 'cmp-nav-line' })));
});
Nav.displayName = 'Nav';
export { Nav };
//# sourceMappingURL=Nav.js.map